import React, { useEffect, useMemo, useState } from "react";

import { assetBase } from "../../../config";
import { useSignAssetUrl } from "../../../core/assetSigs";
import { jsonParser } from "../../../utils/helpers";
import slidePlaceholder from "../../../assets/16x9-placeholder.jpg";

export default function Thumbnail(props) {
  const signUrl = useSignAssetUrl();
  const isLibrarySlide =
    props.slide.initial_presentation === props.presentation.id ? false : true;

  // Library thumbnails live under a different presentation's directory and
  // are signed with that deck's secret — we can't sign them from here, they
  // fall through to the Referer auth check. Local /slides/ thumbnails are
  // also outside the asset_sigs scope and same falls through.
  const rootThumb = isLibrarySlide
    ? `${assetBase}/presentations/${props.slide.initial_presentation}/${props.slide.initial_presentation}/thumbnails/slide_${props.slide.id}_thumbnail.jpg`
    : `${assetBase}/slides/${props.slide.id}/slide_${props.slide.id}_thumbnail.jpg`;

  // slide_json can be tens to hundreds of KB per slide; parsing it for every
  // thumbnail in a long deck stalls the main thread. Only parse when the
  // payload actually mentions a bespoke thumbnail field.
  const bespoke = useMemo(() => {
    const raw = props.slide.slide_json;
    if (!raw) return null;
    if (typeof raw === "string" && raw.indexOf("slideThumbnail") === -1) {
      return null;
    }
    return (
      jsonParser(raw)?.reveal?.slideThumbnail?.field_media_image || null
    );
  }, [props.slide.slide_json]);

  // Use the mtime from the server-side status endpoint as the cache key.
  // Stable URL → browser caches indefinitely; URL changes only when the
  // file on disk actually changes.
  const rawSrc = bespoke
    ? bespoke
    : props.version
    ? `${rootThumb}?v=${props.version}`
    : rootThumb;
  const src = signUrl(rawSrc);

  const [errored, setErrored] = useState(false);

  useEffect(() => {
    setErrored(false);
  }, [src]);

  if (errored) {
    return (
      <div className="no-thumb" data-thumb={src}>
        <img
          src={slidePlaceholder}
          alt="No thumbnail placeholder"
          loading="lazy"
          decoding="async"
        />
      </div>
    );
  }

  return (
    <img
      src={src}
      alt=""
      loading="lazy"
      decoding="async"
      onError={() => setErrored(true)}
    />
  );
}
